export function getLeastAvailableLuggagePerTrip(segments, supportsChildrenTickets) {
    const result = segments.reduce((output, segment) => {
        const travellerCabinLuggage = segment.travellerCabinLuggage?.find((luggage) => supportsChildrenTickets ? luggage.travellerReference === "1" : !!luggage.travellerReference);
        const travellerCheckedLuggage = segment.travellerCheckedLuggage?.find((luggage) => supportsChildrenTickets ? luggage.travellerReference === "1" : !!luggage.travellerReference);
        const isCabinBagAvailable = travellerCabinLuggage?.luggageAllowance.luggageType === "HAND" &&
            travellerCabinLuggage?.luggageAllowance?.maxPiece !== 0;
        if (!isCabinBagAvailable) {
            output.cabinLuggage = false;
        }
        if (!travellerCabinLuggage?.personalItem) {
            output.personalItem = false;
        }
        if (!travellerCheckedLuggage) {
            output.checkedInLuggage = false;
        }
        return output;
    }, {
        cabinLuggage: true,
        personalItem: true,
        checkedInLuggage: true
    });
    return result;
}
